import { GlobalConstants } from "src/data/GlobalConstants";
import { loaderService } from "./loaderService";
import { getToken } from "src/helpers/helperJWT";
import { handleResponse } from "src/util/functions";

const url = GlobalConstants.urlApi;

const uploadFile = (file) => {
	loaderService.showLoader({ label: "Validando reglas..." });

	const formData = new FormData();

	formData.append("app", "maestros");
	formData.append("interface", "pedidoMinimo");
	formData.append("CSV", file);

	const requestOptions = {
		method: "POST",
		headers: {
			Authorization: getToken(),
		},
		body: formData,
	};

	return fetch(`${url}/pedidoMinimo/uploadFile`, requestOptions)
		.then(handleResponse)
		.then((response) => response);
};

const getRegistros = (data = {}) => {
	console.log(data);
	loaderService.showLoader({ label: "Cargando..." });

	const requestOptions = {
		method: "POST",
		headers: {
			Authorization: getToken(),
			"Content-Type": "application/json",
		},
		body: JSON.stringify(data),
	};

	return fetch(`${url}/pedidoMinimo/getRegistros`, requestOptions)
		.then(handleResponse)
		.then((response) => response);
};

const actualizarById = (data) => {
	loaderService.showLoader({ label: "Guardando registro..." });

	const requestOptions = {
		method: "POST",
		headers: {
			Authorization: getToken(),
			"Content-Type": "application/json",
		},
		body: JSON.stringify(data),
	};

	return fetch(`${url}/pedidoMinimo/actualizarById`, requestOptions)
		.then(handleResponse)
		.then((response) => response);
};

const ejecutarPedidoCandado = () => {
	loaderService.showLoader({ label: "Actualizando reglas..." });

	const requestOptions = {
		method: "POST",
		headers: {
			Authorization: getToken(),
		},
	};

	return fetch(`${url}/pedidoMinimo/ejecutarPedidoCandado`, requestOptions)
		.then(handleResponse)
		.then((response) => response);
};

const getFiltros = () => {
	loaderService.showLoader({ label: "Cargando filtros..." });

	const requestOptions = {
		method: "POST",
		headers: {
			Authorization: getToken(),
		},
	};

	return fetch(`${url}/pedidoMinimo/getFiltros`, requestOptions)
		.then(handleResponse)
		.then((response) => response);
};

export const pedidoMinimoService = {
	uploadFile,
	getRegistros,
	actualizarById,
	ejecutarPedidoCandado,
	getFiltros,
};
